
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/zamowienie-w-trakcie",
      function () {
        return require("private-next-pages/zamowienie-w-trakcie.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/zamowienie-w-trakcie"])
      });
    }
  